import { Component, Inject } from '@angular/core';
import { Environment } from '../../classes/environment';


@Component({
	selector: 'footer-login',
	templateUrl: './footer-login.component.html',
	styles: [ `
		.trivLink {
			text-decoration: none;
			color: inherit;
		}
		.trivLink :hover {
			text-decoration: underline;
		}
		.footerLinks {
			margin: 3em 0; display: flex; flex-flow: row nowrap; gap: 1em; justify-content: center;
		}
		@media print {
			.footerLinks {
				display: none;
			}
		}
	` ]
})
export class FooterLoginComponent {


	version: string = this.environment.version;


	constructor(
		@Inject('environment') public environment: Environment,
	) {}


}
